import posthog from "posthog-js";

export const handleError = ({ error, status }: { error: Error; status: number }) => {
  if (status !== 404) {
    posthog.captureException(error);
  }
};
